import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SEOIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SEO",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M29.43 30.57c-.29 0-.58-.11-.81-.33l-5.71-5.71a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l5.71 5.71a1.14 1.14 0 0 1-.81 1.95"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.57 28.28C7.01 28.28.86 22.13.86 14.57S7.01.86 14.57.86s13.71 6.15 13.71 13.71-6.15 13.71-13.71 13.71m0-25.14c-6.3 0-11.43 5.13-11.43 11.43S8.27 26 14.57 26 26 20.87 26 14.57 20.87 3.14 14.57 3.14"
    }), /*#__PURE__*/_jsx("path", {
      d: "M29.43 30.57c-.29 0-.58-.11-.81-.33l-5.97-5.97a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l5.97 5.97a1.14 1.14 0 0 1-.81 1.95"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.57 28.28C7.01 28.28.86 22.13.86 14.57S7.01.86 14.57.86s13.71 6.15 13.71 13.71-6.15 13.71-13.71 13.71m0-25.14c-6.3 0-11.43 5.13-11.43 11.43S8.27 26 14.57 26 26 20.87 26 14.57 20.87 3.14 14.57 3.14"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.35 18.46c-.23 0-.46-.07-.67-.22l-4.09-2.95a1.138 1.138 0 1 1 1.33-1.85l4.09 2.95c.51.37.63 1.08.26 1.59-.22.31-.57.48-.93.48Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.35 18.46c-.22 0-.45-.06-.64-.2-.52-.36-.66-1.07-.3-1.59l5.56-8.17a1.143 1.143 0 1 1 1.89 1.29l-5.56 8.17c-.22.32-.58.5-.95.5M7.43 21.14c-.22 0-.45-.06-.64-.2-.52-.35-.66-1.07-.3-1.59l3.83-5.63c.35-.52 1.07-.66 1.59-.3.52.35.66 1.07.3 1.59l-3.83 5.63c-.22.32-.58.5-.95.5"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.71 15.18c-.55 0-1.04-.4-1.13-.96l-.61-3.76-3.76.61c-.62.11-1.21-.32-1.31-.95-.1-.62.32-1.21.95-1.31l4.89-.79c.62-.11 1.21.32 1.31.95l.79 4.89c.1.62-.32 1.21-.95 1.31-.06.01-.12.02-.18.02Z"
    })]
  }));
};
SEOIcon.displayName = 'SEOIcon';